import React, { createContext, useContext, useState, useEffect } from "react";
import axiosInstance from "../Config/axios";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Loader from "../Components/Loader/Loader";
// import { useNewUser } from "./NewUserContext";

const LoginContext = createContext();
export const useLogin = () => useContext(LoginContext);

export const LoginProvider = ({ children }) => {
  // const { fetchCartCount } = useNewUser();
  const [user, setUser] = useState(() => JSON.parse(localStorage.getItem("user")) || null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const login = async ({ username_or_email, password }) => {
    setLoading(true);
    setError(null);
    try {
      const { data } = await axiosInstance.post("/customer/login/", { username_or_email, password });

      let loggedInUser = data.payload.user;
      if (loggedInUser?.user) {
        loggedInUser = { ...loggedInUser, ...loggedInUser.user };
      }

      localStorage.setItem("user", JSON.stringify(loggedInUser));
      localStorage.setItem("accessToken", data.payload.access);
      localStorage.setItem("refreshToken", data.payload.refresh);
      setUser(loggedInUser);
      // fetchCartCount();

      Swal.fire({
        icon: "success",
        title: "Login Successful",
        text: `Welcome back, ${loggedInUser.first_name || "User"}!`,
        confirmButtonColor: "#B79527", // orange / gold
      cancelButtonColor: "#1C1C1C",
      });

      if(loggedInUser.is_self_pay === false ){

            if( loggedInUser.player_count === 0 && loggedInUser.has_preferences === false  && loggedInUser.has_payment_method === false){
              if(loggedInUser.is_self_pay === false && loggedInUser.has_payment_method === false){
                navigate('/add-card-self-dir');
              }else{
                navigate("/add-child-form");
              }
      
            } else if( loggedInUser.has_payment_method === false){
              if(loggedInUser.is_self_pay === false && loggedInUser.has_payment_method === false){
                navigate('/add-card-self-dir');
              }else{
                navigate("/add-child-form");
              }
      
            } else if(loggedInUser.has_preferences === false){
              navigate("/preferences");
            } else{
              navigate("/");
            }
      }else{
        navigate("/buy-packages");
      }


      return { success: true };

      

    } catch (err) {
      const message = err.response?.data?.detail || "Login failed";
      setError(message);

      Swal.fire({
        icon: "error",
        title: "Login Failed",
        text: message,
        confirmButtonColor: "#B79527", // orange / gold
      cancelButtonColor: "#1C1C1C",
      });

      return { success: false };
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    localStorage.clear();
    // fetchCartCount();
    setUser(null);
    Swal.fire({
      icon: "info",
      title: "Logged Out",
      text: "You have been logged out successfully.",
      confirmButtonColor: "#B79527", // orange / gold
      cancelButtonColor: "#1C1C1C",
    });
    navigate("/login", { replace: true });
  };

  const changePasswordParentProfile = async (data) => {
    const token = localStorage.getItem("accessToken");

    if (!token || !user?.id) {
      Swal.fire({
        icon: "warning",
        title: "Unauthorized",
        text: "You must be logged in to update the profile.",
        confirmButtonColor: "#B79527", // orange / gold
        cancelButtonColor: "#1C1C1C",
      })
      return { success: false };
    }

    try {
      setLoading(true);
      const response = await axiosInstance.patch("/customer/change-password/", data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      localStorage.clear();
      setUser(null);
      Swal.fire({
        icon: "info",
        title: "Logged Out",
        text: "You have been logged out successfully.",
        confirmButtonColor: "#B79527",
        cancelButtonColor: "#1C1C1C",
      });
      navigate("/login", { replace: true });
 
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Update Failed",
        text: err.response?.data?.detail || "Failed to update password.",
        confirmButtonColor: "#B79527", // orange / gold
        cancelButtonColor: "#1C1C1C",
      });
      return { success: false };
    } finally {
      setLoading(false);
    }
  };

  const updateUser = (userData) => {

      localStorage.setItem("user", JSON.stringify(userData.payload.user));
      localStorage.setItem("accessToken", userData.payload.access);
      localStorage.setItem("refreshToken", userData.payload.refresh);
      setUser(userData.payload.user);
      // fetchCartCount();
  }

  // Auto-logout on expired token
  useEffect(() => {
    const interceptor = axiosInstance.interceptors.response.use(
      (res) => res,
      (err) => {
        if (err.redirectToLogin && user) logout();
        return Promise.reject(err);
      }
    );
    return () => axiosInstance.interceptors.response.eject(interceptor);
  }, [user]);

  return (
    <LoginContext.Provider value={{ user,setUser, login, logout, loading, error, changePasswordParentProfile, updateUser }}>
      {loading && (
       <Loader/>
      )}
      {children}
    </LoginContext.Provider>
  );
};
